/**
 * Текст согласия для чекбокса на форме (152-ФЗ, ст. 9).
 */
export function buildPrivacyConsentText(customPrefix?: string): string {
  const prefix = customPrefix?.trim();
  const body =
    "проставляя отметку в данном поле, даю своё согласие на обработку моих персональных данных, указанных мной в настоящей форме.";

  if (!prefix) {
    return `Я, ${body}`;
  }

  const endsWithPunctuation = /[.!?…]$/.test(prefix);
  return endsWithPunctuation ? `${prefix} ${body}` : `${prefix}. ${body}`;
}

/** Label для поля согласия — сохраняется в API, на форме не показывается. */
export function defaultPrivacyFieldLabel(): string {
  return buildPrivacyConsentText();
}
